import { Row, Col, Card, CardBody } from "reactstrap";
import { useEffect, useState } from "react";
import { MEDIA_FIELDS } from "./CONSTANT";
import { FieldInput } from "../../../../components/FieldInput";
import { getContractsDropdown } from "../../../../api/contract";

export default function InvoiceForm({ validation, contractId }) {
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    validation.setFieldValue("contracts", []);
    validation.values.company ? setIsDisabled(false) : setIsDisabled(true);
  }, [validation.values.company]);

  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <Row>
              {MEDIA_FIELDS.map((f) => {
                if (f.key == "invoiceables") {
                  f.apiMeta = f.apiMetaMethod(contractId);
                }
                return <FieldInput key={f.key} f={f} validation={validation} />;
              })}

              <FieldInput
                key={validation.values.company}
                validation={validation}
                f={{
                  label: "Contracts",
                  key: "contracts",
                  type: "select",
                  api: getContractsDropdown,
                  apiResKey: "company_contracts",
                  apiMeta: { companyId: validation.values.company, active: true },
                  isMulti: true,
                  disabled: isDisabled,
                }}
              />
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
